import { Select } from 'components/Select/Select';
import { type JSX, useMemo } from 'react';
import type { AdvancedFilterColumnRecord } from '../AdvancedFilter';

interface Props<TRow> {
  onValueChange: (value: string) => void;
  value: string;
  columns: AdvancedFilterColumnRecord<TRow>;
  /**
   * List of columns that this filter can compare value to.
   * If not present, all columns with same filterType are used.
   */
  comparableColumns?: string[];
  filterType: string;
  column: string;
}

export const ColumnFilterRule = <TRow,>(props: Props<TRow>): JSX.Element => {
  const handleValueChange = (value: string | null) => {
    props.onValueChange(value ?? '');
  };

  const options = useMemo(() => {
    return Object.values(props.columns)
      .filter((c) =>
        props.comparableColumns
          ? // if comparable columns are defined, use those
            props.comparableColumns.includes(c.key)
          : // otherwise, use all columns with the same filter type excluding this column itself
            c.filter !== undefined &&
            c.filter.type === props.filterType &&
            c.key !== props.column &&
            !c.key.startsWith('device.'),
      )
      .map((c) => ({
        label: c.title,
        value: c.key,
      }));
  }, [props.columns, props.column, props.comparableColumns, props.filterType]);

  return (
    <Select
      options={options}
      value={props.value || null}
      onChange={handleValueChange}
      size='small'
    />
  );
};
